var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.revenues)?_c('div',{staticClass:"sub-total"},[_c('span',{staticClass:"alt"},[_vm._v("Jouw omzet (70%)")]),_vm._v(" "),_c('span',[_vm._v("€ "+_vm._s(_vm.formatCurrency(_vm.revenues)))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }